import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles.module.css';

const STEPS = ['Sign in', 'Authorize'];

function AuthorizationProgress({ step }) {
  return (
    <div className={styles.progress} aria-label="Authorization progress">
      {STEPS.map((label, index) => (
        <React.Fragment key={label}>
          <div
            className={`${styles.progressStep} ${
              index === step ? styles.activeProgressStep : ''
            }`}
            aria-current={index === step ? 'step' : undefined}
          >
            <span className={styles.progressCircle}>{index + 1}</span>
            {label}
          </div>
          {index < STEPS.length - 1 && (
            <span className={styles.progressConnector} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

AuthorizationProgress.propTypes = {
  step: PropTypes.number.isRequired,
};

export default AuthorizationProgress;
